import { render, staticRenderFns } from "./MenuSuspenso.vue?vue&type=template&id=c357a40a&scoped=true"
import script from "./MenuSuspenso.vue?vue&type=script&lang=js"
export * from "./MenuSuspenso.vue?vue&type=script&lang=js"
import style0 from "./MenuSuspenso.vue?vue&type=style&index=0&id=c357a40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c357a40a",
  null
  
)

export default component.exports